
<script>
  import LoadingAnimation from './LoadingAnimation.svelte';

  export let visible = false;
</script>

<div class="loadingBackground" class:visible><LoadingAnimation bind:visible /></div>

<style>
  .loadingBackground {
    position: fixed;
    display: none;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    overflow: auto;
    background-color: transparent;
    /* background-color: rgba(0, 0, 0, 0.4); */
  }

  .loadingBackground.visible {
    display: flex;
  }
</style>